import { render } from "./VerifyEmail.vue?vue&type=template&id=770fb0c2"
import script from "./VerifyEmail.vue?vue&type=script&lang=js"
export * from "./VerifyEmail.vue?vue&type=script&lang=js"

import "./VerifyEmail.vue?vue&type=style&index=0&id=770fb0c2&lang=css"
import "./VerifyEmail.vue?vue&type=style&index=1&id=770fb0c2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__